import { render, staticRenderFns } from "./PrizeChallenge.vue?vue&type=template&id=e8ba5842&"
import script from "./PrizeChallenge.vue?vue&type=script&lang=js&"
export * from "./PrizeChallenge.vue?vue&type=script&lang=js&"
import style0 from "./PrizeChallenge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports